export default __webpack_public_path__ + "static/media/5.c643b60c.mp4";